import React from "react";
import {ProductsUIProvider} from "../ProductsUIContext";
import ProductEdit from "./ProductEdit";

export default function ProductEditIndex(
    {
        match: {
            params: {id},
        },
    }
) {
    return (
        <ProductsUIProvider>
            <ProductEdit id={id}/>
        </ProductsUIProvider>
    )
}